import FooterView from './footer_view';

const Footer = FooterView;
export default Footer;
